module.exports = __webpack_public_path__ + "img/alpha-a-circle-outline.8058192.svg";